import type { Recipe } from '../../domain/recipe';

// DE: Deutsche Abendessen, darunter schnelle Abendbrot-Varianten für müde Abende.
// EN: German dinners, including quick "Abendbrot" options for tired evenings.
// prettier-ignore
export const GERMAN_RECIPES: readonly Recipe[] = [
  {
    id: 'potatoes_quark', name: 'Картопля в мундирі з кварком і огірком', cuisine: 'german', meal: 'dinner',
    nameDe: 'Pellkartoffeln mit Quark und Gurke',
    activeMinutes: 10, totalMinutes: 30, baseServings: 4, lunchboxFriendly: true, backupKit: false,
    ingredients: [
      { productId: 'potato', quantity: 600 }, { productId: 'quark', quantity: 750 },
      { productId: 'cucumber', quantity: 1 }, { productId: 'dill', quantity: 1 }, { productId: 'oil', quantity: 40 },
    ],
    steps: [
      'Зварити картоплю в шкірці (25 хвилин).',
      'Змішати кварк з тертим огірком, кропом, сіллю й ложкою олії.',
      'Подавати картоплю з кварком.',
    ],
    stepsDe: [
      'Kartoffeln mit Schale kochen (25 Minuten).',
      'Quark mit geriebener Gurke, Dill, Salz und einem Löffel Öl verrühren.',
      'Kartoffeln mit dem Quark servieren.',
    ],
  },
  {
    id: 'bauernfruehstueck', name: 'Смажена картопля з яйцями (Bauernfrühstück)', cuisine: 'german', meal: 'dinner',
    nameDe: 'Bauernfrühstück',
    activeMinutes: 15, totalMinutes: 30, baseServings: 4, lunchboxFriendly: false, backupKit: false,
    meatAddOn: { productId: 'bacon', quantityPerPortion: 30 },
    ingredients: [
      { productId: 'potato', quantity: 600 }, { productId: 'eggs', quantity: 10 }, { productId: 'onion', quantity: 150 },
      { productId: 'cucumber', quantity: 1 }, { productId: 'oil', quantity: 30 },
    ],
    steps: [
      'Зварити картоплю, нарізати скибками.',
      'Обсмажити картоплю з цибулею до скоринки.',
      'Залити збитими яйцями й смажити до готовності, подавати з огірком.',
    ],
    stepsDe: [
      'Kartoffeln kochen und in Scheiben schneiden.',
      'Kartoffeln mit Zwiebel knusprig braten.',
      'Verquirlte Eier darübergießen, stocken lassen und mit Gurke servieren.',
    ],
  },
  {
    id: 'potato_salad', name: 'Картопляний салат з копченим лососем', cuisine: 'german', meal: 'dinner',
    nameDe: 'Kartoffelsalat mit Räucherlachs',
    activeMinutes: 15, totalMinutes: 30, baseServings: 4, lunchboxFriendly: true, backupKit: false,
    ingredients: [
      { productId: 'potato', quantity: 600 }, { productId: 'smoked_salmon', quantity: 300 },
      { productId: 'cucumber', quantity: 1 }, { productId: 'yogurt', quantity: 300 }, { productId: 'eggs', quantity: 4 },
      { productId: 'dill', quantity: 1 }, { productId: 'spring_onion', quantity: 1 },
    ],
    steps: [
      'Зварити картоплю й яйця, остудити.',
      'Нарізати картоплю, яйця, огірок і зелену цибулю.',
      'Заправити йогуртом з кропом, додати лосось.',
    ],
    stepsDe: [
      'Kartoffeln und Eier kochen und abkühlen lassen.',
      'Kartoffeln, Eier, Gurke und Frühlingszwiebeln schneiden.',
      'Mit Dill-Joghurt anmachen und den Lachs dazugeben.',
    ],
  },
  {
    id: 'fish_spinach_mash', name: 'Риба зі шпинатом і картопляним пюре', cuisine: 'german', meal: 'dinner',
    nameDe: 'Fisch mit Spinat und Kartoffelpüree',
    activeMinutes: 15, totalMinutes: 30, baseServings: 4, lunchboxFriendly: true, backupKit: false,
    ingredients: [
      { productId: 'pollock', quantity: 800 }, { productId: 'potato', quantity: 600 }, { productId: 'spinach', quantity: 450 },
      { productId: 'milk', quantity: 200 }, { productId: 'butter', quantity: 50 },
    ],
    steps: [
      'Зварити картоплю й розім’яти з молоком і маслом.',
      'Запекти або обсмажити рибу 10 хвилин.',
      'Прогріти шпинат і подавати все разом.',
    ],
    stepsDe: [
      'Kartoffeln kochen und mit Milch und Butter stampfen.',
      'Fisch 10 Minuten backen oder braten.',
      'Spinat erhitzen und alles zusammen servieren.',
    ],
  },
  {
    id: 'lentil_stew', name: 'Сочевичний айнтопф з морквою', cuisine: 'german', meal: 'dinner',
    nameDe: 'Linseneintopf mit Karotten',
    activeMinutes: 15, totalMinutes: 35, baseServings: 4, lunchboxFriendly: true, backupKit: false,
    meatAddOn: { productId: 'sausages', quantityPerPortion: 75 },
    ingredients: [
      { productId: 'lentils', quantity: 320 }, { productId: 'carrot', quantity: 300 }, { productId: 'onion', quantity: 150 },
      { productId: 'canned_tomatoes', quantity: 400 }, { productId: 'broth', quantity: 2 },
      { productId: 'sour_cream', quantity: 200 }, { productId: 'oil', quantity: 20 },
    ],
    steps: [
      'Обсмажити цибулю й моркву.',
      'Додати сочевицю, томати й 1 л бульйону.',
      'Варити 20 хвилин до м’якості, подавати зі сметаною.',
    ],
    stepsDe: [
      'Zwiebel und Karotte anbraten.',
      'Linsen, Tomaten und 1 l Brühe dazugeben.',
      '20 Minuten weich kochen und mit Schmand servieren.',
    ],
  },
  {
    id: 'tuna_salad', name: 'Салат з тунцем, квасолею та яйцем', cuisine: 'german', meal: 'dinner',
    nameDe: 'Salat mit Thunfisch, Bohnen und Ei',
    activeMinutes: 15, totalMinutes: 15, baseServings: 4, lunchboxFriendly: true, backupKit: false,
    ingredients: [
      { productId: 'tuna', quantity: 370 }, { productId: 'kidney_beans', quantity: 400 }, { productId: 'eggs', quantity: 4 },
      { productId: 'corn', quantity: 340 }, { productId: 'cucumber', quantity: 1 }, { productId: 'yogurt', quantity: 200 },
      { productId: 'spring_onion', quantity: 1 }, { productId: 'lettuce', quantity: 1 },
    ],
    steps: [
      'Зварити яйця.',
      'Нарізати салат, огірок і зелену цибулю, додати квасолю, кукурудзу й тунець.',
      'Заправити йогуртом і додати яйця.',
    ],
    stepsDe: [
      'Eier kochen.',
      'Salat, Gurke und Frühlingszwiebeln schneiden, Bohnen, Mais und Thunfisch dazugeben.',
      'Mit Joghurt anmachen und die Eier dazugeben.',
    ],
  },
  {
    id: 'abendbrot', name: 'Вечеря по-німецьки: хліб з лососем і вершковим сиром', cuisine: 'german', meal: 'dinner',
    nameDe: 'Abendbrot: Brot mit Lachs und Frischkäse',
    activeMinutes: 10, totalMinutes: 10, baseServings: 4, lunchboxFriendly: true, backupKit: false,
    meatAddOn: { productId: 'ham', quantityPerPortion: 50 },
    ingredients: [
      { productId: 'bread', quantity: 500 }, { productId: 'smoked_salmon', quantity: 200 },
      { productId: 'cream_cheese', quantity: 200 }, { productId: 'cucumber', quantity: 1 },
      { productId: 'tomato', quantity: 300 },
    ],
    steps: [
      'Нарізати хліб, огірок і помідори.',
      'Намастити хліб вершковим сиром і викласти лосось та овочі.',
    ],
    stepsDe: [
      'Brot, Gurke und Tomaten schneiden.',
      'Brot mit Frischkäse bestreichen und mit Lachs und Gemüse belegen.',
    ],
  },
];
